import React from "react";
import { type LucideIcon, Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

type TooltipWithIconProps = {
  content: React.ReactNode;
  children?: React.ReactNode;
  icon?: LucideIcon;
  iconProps?: React.ComponentProps<LucideIcon>;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
  delayDuration?: number;
  className?: string;
  iconClassName?: string;
  tooltipClassName?: string;
  divRef?: React.ForwardedRef<HTMLDivElement>;
};

export function TooltipWithIcon({
  content,
  children,
  icon: Icon,
  iconProps = { size: 16 },
  side = "top",
  align = "center",
  delayDuration = 300,
  className = "",
  iconClassName = "",
  tooltipClassName = "",
}: TooltipWithIconProps) {
  // Default icon is Info if none provided and no children
  const IconComponent = Icon || (children ? null : Info);

  return (
    <TooltipProvider>
      <Tooltip delayDuration={delayDuration}>
        <TooltipTrigger asChild>
          <span className={`inline-flex items-center ${className}`}>
            {children}
            {IconComponent && !children && (
              <IconComponent
                className={`cursor-help ${iconClassName}`}
                aria-hidden="true"
                {...iconProps}
              />
            )}
            {IconComponent && children && (
              <IconComponent
                className={`cursor-help ${iconClassName}`}
                aria-hidden="true"
                {...iconProps}
              />
            )}
          </span>
        </TooltipTrigger>
        <TooltipContent
          side={side}
          align={align}
          // className="max-w-sm lg:md:max-w-lg min-w-40"
          className={tooltipClassName}
        >
          {content}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
